module.exports = fox._r("images/like.gif", __webpack_public_path__ + "images/like.gif");


//////////////////
// WEBPACK FOOTER
// ./images/like.gif
// module id = 1070
// module chunks = 4